import { render, staticRenderFns } from "./PosterPreview.vue?vue&type=template&id=8ee98e96&scoped=true"
import script from "./PosterPreview.vue?vue&type=script&lang=ts"
export * from "./PosterPreview.vue?vue&type=script&lang=ts"
import style0 from "./PosterPreview.vue?vue&type=style&index=0&id=8ee98e96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ee98e96",
  null
  
)

export default component.exports